/* An approved editorial asset may fail independently; retain its native product image. */
(()=>{
  'use strict';
  if(window.r26JewelryPhotoFallback)return;window.r26JewelryPhotoFallback=true;
  const recover=img=>{
    if(!(img instanceof HTMLImageElement)||!img.hasAttribute('data-r26-jewelry-photo'))return;
    const source=img.dataset.nativeFallback;
    img.removeAttribute('data-r26-jewelry-photo');
    if(!source)return;
    img.removeAttribute('srcset');img.removeAttribute('sizes');img.dataset.photoFallback='native';img.src=source;
  };
  document.addEventListener('error',event=>recover(event.target),true);
  document.querySelectorAll('img[data-r26-jewelry-photo]').forEach(img=>{if(img.complete&&!img.naturalWidth)recover(img);});
})();
